export default __webpack_public_path__ + "static/media/ui-logo.e8259726.svg";